import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Privacy',
  templateUrl: './Privacy.component.html',
  styleUrls: ['./Privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
